// ============================================================
// [2.13.0] Connexion à la console d'administration d'un serveur Siverix avec
// son compte Siverix, par redirection (le CORS du serveur de comptes refuse
// les pages des serveurs Siverix) :
//
//   1. console du serveur Siverix -> <émetteur>/admin/#/sso?audience=<origine>
//   2. console du serveur de comptes : consentement, puis assertion pour
//      <origine> et retour vers <origine>/admin/#/sso-retour?assertion=…&issuer=…
//   3. console du serveur Siverix : POST /auth/sso/login, session ouverte.
//
// L'adresse de retour est TOUJOURS dérivée de l'audience (origine + /admin/) :
// aucun paramètre « retour » libre, donc pas de redirection ouverte. L'assertion
// voyage dans le fragment (#…), jamais envoyé au serveur ni dans le Referer.
// Fonctions pures, sans DOM.
// ============================================================
/**
 * Valide l'audience demandée à l'écran de consentement : une adresse http(s)
 * réduite à son origine (schéma, hôte, port). Refusée : chemin, requête,
 * fragment, identifiants, autre schéma. « https://Ami.fr:443/ » est acceptée et
 * rendue sous sa forme d'origine (« https://ami.fr »).
 */
export function parseConsoleAudience(raw) {
    const value = typeof raw === 'string' ? raw.trim() : '';
    if (value === '')
        return { ok: false, reason: 'missing' };
    if (!/^https?:\/\//i.test(value))
        return { ok: false, reason: 'invalid' };
    let u;
    try {
        u = new URL(value);
    }
    catch {
        return { ok: false, reason: 'invalid' };
    }
    if ((u.protocol !== 'http:' && u.protocol !== 'https:') || u.hostname === '') {
        return { ok: false, reason: 'invalid' };
    }
    // `new URL` avale « ? » et « # » vides et les « \ » : on regarde aussi le texte.
    if (u.username !== '' ||
        u.password !== '' ||
        u.pathname !== '/' ||
        u.search !== '' ||
        u.hash !== '' ||
        /[?#@\\]/.test(value) ||
        /^https?:\/\/[^/]*\/./i.test(value)) {
        return { ok: false, reason: 'not-origin' };
    }
    return { ok: true, origin: u.origin };
}
/** Adresse de la console d'administration d'un serveur Siverix (origine + /admin/). */
export function consoleUrlOf(origin) {
    return `${origin.replace(/\/+$/, '')}/admin/`;
}
/** Écran de consentement du serveur de comptes, pour la console de `audienceOrigin`. */
export function buildSsoConsentUrl(issuer, audienceOrigin) {
    return `${consoleUrlOf(issuer.trim())}#/sso?audience=${encodeURIComponent(audienceOrigin)}`;
}
/** Retour vers la console du serveur Siverix, assertion dans le fragment. */
export function buildSsoReturnUrl(audienceOrigin, assertion, issuer) {
    const q = new URLSearchParams({ assertion, issuer });
    return `${consoleUrlOf(audienceOrigin)}#/sso-retour?${q.toString()}`;
}
